
import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Trash2 } from 'lucide-react';
import { UnifiedGdprPanel } from './gdpr/UnifiedGdprPanel';

export function GDPRDeletionManagementPanel() {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Trash2 className="h-5 w-5" />
          GDPR Deletion Management
        </CardTitle>
        <CardDescription>
          Centralized system for managing all phases of GDPR-compliant user deletion with unified operations and monitoring
        </CardDescription>
      </CardHeader>
      <CardContent>
        <UnifiedGdprPanel />
      </CardContent>
    </Card>
  );
}
